const DOCUMENTS_PATHS = {
  BASE: '/api/v1/documents',
  DETAIL: (documentId: string) => `/api/v1/documents/${documentId}`,
  TYPES: {
    BASE: '/api/v1/documents/types',
  },
  STATES: {
    BASE: '/api/v1/document-states',
  },
  DTE_STATUS: {
    BASE: '/api/v1/dte-response-status',
  },
  MOVEMENTS: {
    BASE: '/api/v1/dicom-document-movements-tracking',
  },
};

export { DOCUMENTS_PATHS };
